import { Component, inject, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";

import { DataTableComponent } from "../../table/data-table/data-table";

@Component({
  selector: "adaa-team-members-view-modal",
  imports: [TranslatePipe, DataTableComponent],
  templateUrl: "./team-members-view-modal.html",
  styleUrl: "./team-members-view-modal.scss",
})
export class TeamMembersViewModalComponent {
  modal: NgbActiveModal = inject(NgbActiveModal);

  @Input() teamMembers: object[] = [];
  @Input() configKey: string = "";
  @Input() title: string = "";
}
